import React, { useState, useEffect } from "react";
import Select from "react-select"
import { navigate } from "gatsby";
import $ from 'jquery'

function SearchResultsPagination(props) {
    const [pagenumber, setPageNumber] = useState(props.current_page_number+1);
    const page_options = [] 
    let i = 1;
    while (i <= props.number_of_pages) {
        page_options.push({ value: i, label: i, })
        i++;
    }
    const pageChange = event => {
        setPageNumber((event.value))
        let pageUrl = 'page-' + ((event.value)) + '/';
        //get current url
        const urlwithoutsort = (props?.location_path).split("page-");
        // concat url and navigate  
        if(event.value == 1) {
            navigate(urlwithoutsort[0])
        }else {
            navigate(urlwithoutsort[0] + pageUrl)
        }
        var target = $("body");
        $('html,body').animate({
            scrollTop: target.offset().top - 250
        },100);
    }
    console.log('current_page_number',  props.current_page_number)
    return (

        <div className="al-pagination">
            Page 
            <Select
                options={page_options}
                placeholder={(props.current_page_number + 1)}
                classNamePrefix={"select-opt"}
                isSearchable={false}
                onChange={pageChange}
                styles={customStyles}  
                value={page_options.find(
                  obj => obj.value === (props.current_page_number + 1)
                )}
                // defaultValue={"1"}
            />
            of {props.number_of_pages}
        </div>
    );
}


const customStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#B20838" : null,
        color: isFocused ? "#ffffff" : "#575757",
      }
    },
    control: styles => ({
      ...styles,
      backgroundColor: null, 
      width:"80px",
      borderRadius: "4px",
      paddingLeft: "15px",
    //   height: "40px",
    //   boxShadow: "none",
      color: "#4c505b",
      fontSize: "14px",
      fontWeight: "300",
    }),
    valueContainer: styles => ({
      ...styles,
      fontSize: ".875rem",
      paddingLeft: 0,
      paddingRight: 0,
      lineHeight: "30px",
      fontWeight: "300",
      cursor: "pointer",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      //  color: "#ffffff",
    }),
    indicatorsContainer: styles => ({
      ...styles,
      // color: '#ffffff',
      padding: 0,
      cursor: "pointer",
    }),
    indicatorSeparator: () => null,
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: "#4c505b",
        marginLeft: 0,
      }
    },
  }

export default SearchResultsPagination